export type HttpQueryValue = string | number | boolean | null | undefined;

export type HttpQuery = Readonly<Record<string, HttpQueryValue>>;

export interface HttpRequest {
  readonly path: string;
  readonly query?: HttpQuery;
}

export abstract class HttpClientPort {
  abstract get(request: HttpRequest): Promise<unknown>;

  abstract getAbsolute(url: string): Promise<unknown>;
}
